module.exports = __webpack_public_path__ + "images/Group 125613cde5e45ff6e9d72ec00fda863d63c4.svg";